import * as moment from 'moment';

export default (): string =>
  moment()
    .startOf('day')
    .toISOString();
